import './component.scss';
import './images/icon_arrow_left.svg';
import './images/icon_arrow_right.svg';
import './images/icon_mail.svg';
import './images/no_image.svg';

// Splideライブラリのインポート
import Splide from '@splidejs/splide';
import '@splidejs/splide/css';

// FV画像スライダーの初期化
document.addEventListener('DOMContentLoaded', () => {
  initFvImageSliders();
});

function initFvImageSliders() {
  const sliders = document.querySelectorAll('.fv-image-slider__carousel');

  sliders.forEach((slider) => {
    if (!slider.id) return;

    // Splideが読み込まれているか確認
    if (typeof Splide === 'undefined') {
      console.warn('Splide is not loaded');
      return;
    }

    const splide = new Splide(`#${slider.id}`, {
      type: 'slide',
      perPage: 1,
      pagination: false,
      arrows: true,
      drag: true,
      type: 'loop'
    });

    // サムネイルクリックでスライド切り替え
    const container = slider.closest('.fv-image-slider');
    const thumbnails = container?.querySelectorAll('.fv-image-slider__thumbnail[data-index]');
    const photoCta = container?.querySelector('.fv-image-slider__photo-cta');

    if (thumbnails) {
      thumbnails.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const index = parseInt(thumb.dataset.index, 10);
          splide.go(index);
        });
      });

      // 写真CTAクリックでCTAスライドに移動
      if (photoCta) {
        photoCta.addEventListener('click', (e) => {
          e.preventDefault();
          splide.go(thumbnails.length); // CTAスライドは画像の次のインデックス
        });
      }

      // スライド変更時にサムネイルのアクティブ状態を更新
      splide.on('move', (newIndex) => {
        const isCtaSlide = newIndex === thumbnails.length;

        thumbnails.forEach((thumb, i) => {
          if (i === newIndex) {
            thumb.classList.add('fv-image-slider__thumbnail--active');
          } else {
            thumb.classList.remove('fv-image-slider__thumbnail--active');
          }
        });

        // 写真CTAのアクティブ状態を更新
        if (photoCta) {
          if (isCtaSlide) {
            photoCta.classList.add('fv-image-slider__photo-cta--active');
          } else {
            photoCta.classList.remove('fv-image-slider__photo-cta--active');
          }
        }
      });
    }

    splide.mount();
  });
}
